import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Wrench } from "lucide-react";

// Banner ADMIN (după ora 20:00): șoferii care nu au completat rubricile din Întreținere mașini.
export default function MaintenanceMissingBanner() {
  const [report, setReport] = useState(null);
  const after20 = new Date().getHours() >= 20;

  useEffect(() => {
    if (!after20) return;
    api.get("/car-maintenance/missing-report").then((r) => setReport(r.data)).catch(() => {});
  }, [after20]);

  if (!after20 || !report || (report.missing || []).length === 0) return null;

  return (
    <div className="rounded-lg border-2 border-red-500 bg-red-50 p-4" data-testid="maintenance-missing-banner">
      <div className="flex items-center gap-2 font-bold text-red-900 mb-2">
        <Wrench size={18} /> 🌙 Șoferi care NU au completat Întreținere mașini săptămâna asta ({report.missing.length})
      </div>
      <div className="space-y-1.5">
        {report.missing.map((m) => (
          <div key={m.person_id} className="text-sm flex items-center gap-2 flex-wrap bg-white/60 rounded px-2 py-1.5" data-testid={`maint-missing-${m.person_id}`}>
            <strong className="text-red-800">{m.name}</strong>
            <span className="text-xs text-zinc-600">🚙 {(m.cars || []).join(", ")}</span>
            <span className="text-xs text-red-700 font-semibold ml-auto">Lipsă: {(m.missing || []).join(" + ")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
